export default "__VITE_ASSET__DEVFnD3n__"